import { apiClient, type ApiClientResponse, routes } from 'common/services';
import { type UserRSVP } from '../types';

export const updateEventUserStatus = async (eventId: string, statusToApply: UserRSVP) =>
  apiClient.post<undefined, ApiClientResponse<undefined>>(routes.events.updateUserStatus(eventId), {
    rsvp: statusToApply,
  });
